<app-navbar></app-navbar>
<router-outlet></router-outlet>
<app-footer></app-footer>
<ngx-scrolltop
  backgroundColor="var(--mainColor)"
  symbolColor="#fff"
></ngx-scrolltop>
